<template>
  <div class="container">
    <table class="table table-hover">
      <thead>
        <tr>
          <th scope="col">Scholarship Name</th>
          <th scope="col">Organization</th>
          <th scope="col">Status</th>
        </tr>
      </thead>
      <router-link v-for="sub in submissions" v-bind:key="sub.schol_name"
        :to="{ name: 'review',
            params: { organization_name: sub.org_canonical_name,
              scholarship_name: sub.schol_canonical_name }}"
        tag="tbody">
        <tr>
          <td>{{sub.schol_name}}</td>
          <td>{{sub.org_name}}</td>
          <td>{{sub.status? 'Submitted': 'Unsubmitted'}}</td>
        </tr>
      </router-link>
    </table>
  </div>
</template>

<script>
export default {
  name: "Submissions",
  props: {
    submissions: Array
  },
  data(){
    return{
    }
  },
  mounted(){
  },
  methods:{
    
  }
}
</script>

<style>
</style>
